import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ibmCloud = defineConnector({
  identifier: "ibmCloud",
  name: "IBM Cloud",
  tagLine: "Enterprise cloud platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://[^/]*\\.cloud\\.ibm\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://iam.cloud.ibm.com/identity/token",
        formBody: {
          grant_type: "urn:ibm:params:oauth:grant-type:apikey",
          apikey: app.secret.apiKey,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create an IBM Cloud API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [IBM Cloud console](https://cloud.ibm.com/iam/apikeys), go to **Manage > Access (IAM) > API keys** and click **Create an IBM Cloud API key**.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "IBM Cloud API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://iam.cloud.ibm.com/identity/token",
  },
});
